import { render, staticRenderFns } from "./ImsTags.vue?vue&type=template&id=04ba0398&scoped=true"
import script from "./ImsTags.vue?vue&type=script&lang=js"
export * from "./ImsTags.vue?vue&type=script&lang=js"
import style0 from "./ImsTags.vue?vue&type=style&index=0&id=04ba0398&prod&scoped=true&lang=css"
import style1 from "./ImsTags.vue?vue&type=style&index=1&id=04ba0398&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ba0398",
  null
  
)

export default component.exports